<!--
 * @Author:
 * @LastEditTime: 2026-01-08 11:43:07
 * @Description:
-->
<!--  -->
<template>
  <div class="h-full w-full training-container">
    <!-- 顶部 -->
    <div class="w-full flex justify-between items-center training-header ">
      <div class="h-full flex-1 relative" v-for="item in headerImgs" :key="item.key">
        <span
          v-if="item.text"
          class="text-white text-2xl font-bold absolute top-2/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 header-text"
          >{{ item.text }}</span
        >
        <img :src="item.src" alt="" class="h-full w-full" />
      </div>
    </div>
    <div
      class="btn cursor-pointer w-100px h-35px absolute right-1/50 top-1/20"
      @click="handleHistory"
    >
      {{ isHistory ? '返回' : '历史成绩' }}
    </div>
    <!-- 内容 -->
    <div class="w-full mt-30px flex justify-center items-center  flex-col content-container">
      <div class="title-container" v-if="!openDialog">
        {{ isHistory ? '历史成绩' : '方案列表' }}
      </div>
      <!-- 列表 -->
      <div class="w-650px" v-if="!isHistory && !openDialog">
        <div class="custom-scrollbar w-full h-600px overflow-y-auto mt-20px">
          <div
            class="w-97/100  h-150px mb-20px p-0px cursor-pointer"
            v-for="item in list"
            :key="item.id"
            @click="handleItem(item)"
            :class="{
              'list-item-active': currentItem.id === item.id,
              'list-item': currentItem.id !== item.id,
            }"
          >
            <div class="h-100px w-150px mt-25px ml-30px list-bg">
              <img src="../images/machine.png" alt="" class="h-60px w-140px mt-20px" />
            </div>
            <div class="text-white p-10px pt-30px">
              <div class="text-18px mb-10px">{{ item.name }}</div>
              <div class="text-14px text-[#00c0ff]">{{ item.remark }}</div>
            </div>
          </div>
        </div>
        <div class="w-full h-40px flex justify-around items-center mt-30px">
          <div class="cursor-pointer btn w-90px h-35px leading-30px" @click="operation('add')">
            新增
          </div>
          <div class="cursor-pointer btn w-90px h-35px leading-30px" @click="operation('edit')">
            编辑
          </div>
          <div class="cursor-pointer btn w-90px h-35px leading-30px" @click="operation('study')">
            学习
          </div>
          <div class="cursor-pointer btn w-90px h-35px leading-30px" @click="operation('delete')">
            删除
          </div>
        </div>
      </div>
      <!-- 历史成绩 -->
      <div class="w-1100px mt-30px  history-container" v-if="isHistory && !openDialog">
        <div class="flex mb-10px">
          <el-input
            class="mr-12/25"
            v-model.trim="search.learningUserName"
            size="small"
            :placeholder="$t('用户名搜索')"
            clearable
            prefix-icon="el-icon-search"
            @input="searchList"
            :style="{ width: '220px !important' }"
          ></el-input>
          <div class="flex w-350px">
            <span class="mr-8px text-center leading-30px text-[#9ebee0]">排序方式</span>
            <el-select
              v-model="search.sortWay"
              class="w-220px mr-10px"
              size="small"
              placeholder="排序方式"
              clearable
              @change="searchList"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="(item, index) in sortWaysList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>

          <el-button type="primary" size="small" @click="exportExcel">{{ $t('导出') }}</el-button>
        </div>
        <el-table
          :data="tableData"
          v-loading="loading"
          :highlight-current-row="true"
          row-key="id"
          :height="550"
        >
          <el-table-column
            show-overflow-tooltip
            :label="$t('用户名')"
            prop="learningUserName"
            align="center"
          />
          <el-table-column
            show-overflow-tooltip
            :label="$t('方案名称')"
            prop="solutionName"
            align="center"
          />
          <el-table-column
            show-overflow-tooltip
            :label="$t('操作类型')"
            prop="disAssembleyOperationTypeString"
            min-width="120"
            align="center"
          />
          <el-table-column
            show-overflow-tooltip
            :label="$t('考核方式')"
            prop="disAssembleyTestTypeString"
            align="center"
          />
          <el-table-column show-overflow-tooltip :label="$t('得分')" prop="grade" align="center" />
          <el-table-column
            show-overflow-tooltip
            :label="$t('开始时间')"
            prop="creationTime"
            align="center"
          />
          <el-table-column
            show-overflow-tooltip
            :label="$t('考核耗时')"
            prop="duration"
            align="center"
          />
        </el-table>
        <el-pagination
          class="float-right mt-20px ml-10px"
          @size-change="searchList"
          @current-change="getHistory"
          :current-page.sync="search.pageNo"
          :page-sizes="[15, 30, 50, 100]"
          :page-size.sync="search.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="search.pageTotal"
          popper-class="current-popper"
        ></el-pagination>
      </div>
      <AddDialog v-if="openDialog" :visible.sync="openDialog" @refresh="getTrainingList" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import FnMixins from '@/assets/js/fnMixins'
import {
  EquipDisAssembleyLearnRecordApi,
  EquipDisAssembleySolutionApi,
} from '@wiz-api/equipment-assembly-trainning'

const equipDisAssembleyLearnRecord = new EquipDisAssembleyLearnRecordApi()
const equipDisAssembleySolution = new EquipDisAssembleySolutionApi()
const AddDialog = () => {
  return import('../components/AddDialog')
}
export default {
  name: '',
  mixins: [FnMixins],
  components: {
    AddDialog,
  },
  data() {
    return {
      headerImgs: [
        {
          key: 'left',
          src: require('../images/training_left.png'),
        },
        {
          key: 'center',
          src: require('../images/training_center.png'),
          text: '设备拆解培训',
        },
        {
          key: 'right',
          src: require('../images/training_right.png'),
        },
      ],
      search: {
        name: '',
        sort: '',
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sortWaysList: [
        {
          value: 'learningUserName',
          name: '用户名',
        },
        {
          value: 'solutionName',
          name: '方案名称',
        },
        {
          value: 'disAssembleyOperationType',
          name: '操作类型',
        },
        {
          value: 'disAssembleyTestType',
          name: '考核方式',
        },
        {
          value: 'grade',
          name: '得分',
        },
        {
          value: 'startTime',
          name: '开始时间',
        },
        {
          value: 'duration',
          name: '考核耗时',
        },
      ],
      tableData: [],
      loading: false,
      isHistory: false,
      openDialog: false,
      list: [],
      currentItem: {},
    }
  },
  computed: {
    // 兼容除saas其他项目使用该模块
    basePath() {
      const routerBase = _.get(Wiz, 'globalSettings.globalConfig.routerBase')
      if (Array.isArray(routerBase)) {
        // 多个微服务场景取第一个基础微服务
        return `/${routerBase[0]}`
      }
      return routerBase ? `/${routerBase}` : ''
    },
  },
  methods: {
    handleHistory() {
      this.isHistory = !this.isHistory
      console.log(this.isHistory)
      // true getHistory, false getTraining
      if (this.isHistory) {
        this.getHistory()
      } else {
        this.getTrainingList()
      }
    },
    handleItem(item) {
      console.log(item)
      this.currentItem = item.id === this.currentItem.id ? {} : item
      console.log(this.currentItem)
    },
    async operation(type) {
      if (['edit', 'delete', 'study'].includes(type) && _.isEmpty(this.currentItem)) {
        this.$message({
          message: `请先选择要${
            type === 'edit' ? '编辑' : type === 'delete' ? '删除' : '学习'
          }的方案`,
          type: 'warning',
        })
        return
      }
      switch (type) {
        case 'add':
          this.openDialog = true
          break
        case 'delete':
          this.$confirm('是否确认删除当前选中的文件或文件夹?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(async () => {
            // 接口
            const [err, res] = await equipDisAssembleySolution.callDelete(this.currentItem.id)
            if (!err && !res) {
              this.$message({
                message: '删除成功',
                type: 'info',
              })
              this.getTrainingList()
            }
          })
          break
        case 'edit':
          this.$router.push(
            `${this.basePath}/equipment-disassemble-training/modify-training?id=${this.currentItem.id}`
          )
          break
        case 'study':
          this.$router.push(
            `${this.basePath}/equipment-disassemble-training/study-scheme?id=${this.currentItem.id}`
          )
          break
        default:
          break
      }
    },
    searchList() {
      this.search.pageNo = 1
      this.getHistory()
    },
    exportExcel() {
      this.$confirm('确认要导出历史成绩吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await equipDisAssembleyLearnRecord.exportQueryLearningRecord({
            sorting: this.search.sortWay,
            learningUserName: this.search.learningUserName,
            skipCount: (this.search.pageNo - 1) * this.search.pageSize,
            maxResultCount: this.search.pageSize,
          })
          console.log(err, res)
          if (!err && res) {
            this.downLoadBlob({ name: '历史成绩.xlsx', data: res })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出',
          })
        })
    },
    async getHistory() {
      const [err, res] = await equipDisAssembleyLearnRecord.queryLearningRecord({
        siteId: null,
        sorting: this.search.sortWay,
        learningUserName: this.search.learningUserName,
        skipCount: (this.search.pageNo - 1) * this.search.pageSize,
        maxResultCount: this.search.pageSize,
      })
      if (!err && res) {
        this.tableData = res.items
        this.search.pageTotal = res.totalCount
      }
    },
    async getTrainingList() {
      const [err, res] = await equipDisAssembleySolution.getList({
        siteId: null,
        skipCount: 0,
        maxResultCount: 1000,
      })
      if (!err && res) {
        this.list = res.items
      }
    },
  },
  created() {
    this.getTrainingList()
  },
  mounted() {},
}
</script>
<style lang="scss" scoped>
@import '../css/index.scss';
.h-35px {
  height: 35px !important;
}

.training-container {
  background-image: url('../images/background.jpg');
  background-size: 100% 100%;
}
.content-container{
  height: calc(100% - 120px) !important;
}
.training-header {
  height: 80px !important;
  .header-text {
    transform: translate(-50%, -50%) !important;
  }
}
.btn {
  text-align: center;
  color: #fff !important;
  background: url('../images/button.png') no-repeat !important;
  padding: 0px !important;
  line-height: 30px !important;
  background-size: 100% 100% !important;
}
.title-container {
  width: 290px !important;
  text-align: center;
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  background-image: url('../images/ornamen.png');
  background-size: 100% 100%;
}
.list-item {
  display: flex;
  background-image: url('../images/Unchecked.png');
  background-size: 100% 100%;
}
.list-item-active {
  display: flex;
  background-image: url('../images/checked.png');
  background-size: 100% 100%;
}
.list-bg {
  background-image: url('../images/Frame.png');
  background-size: 100% 100%;
}
</style>
<style lang="scss">
.current-popper {
  background-color: #0a2247 !important;
  border: none;
  .el-scrollbar {
    background-color: #0a2247 !important;
    border: none !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }
    .el-select-dropdown__item.hover {
      color: #fff !important;
      background-color: #133064cc !important;
    }
    .el-select-dropdown__item.selected {
      color: #fff !important;
      background-color: #133064cc !important;
    }
  }
  .popper__arrow::after {
    border-bottom-color: #0a2247 !important;
    border-top-color: #0a2247 !important;
    border-color: #042f61 !important;
  }
}
</style>
